import React from 'react';
import { LessonProvider } from '../../contexts/lessonContext';
import { Lesson as LessonComponent } from './Lesson';

const Lesson = (): JSX.Element => {
  return (
    <LessonProvider>
      <LessonComponent />
    </LessonProvider>
  );
};

export { Lesson };
